import {
  USR_CONFIGURACAO_NOTIFICACAO_SUCESSO,
  USR_SET_PESSOA_LOGADA_SUCCESS,
  USR_SET_PESSOA_SUCCESS,
} from '../actions/types';

const INITIAL_STATE = {
  pessoaLogada: {},
  dadosPessoa: {
    nome: '',
    cpf: '',
    logradouro: '',
    numero: '',
    complemento: '',
    bairro: '',
    cep: '',
    telefoneFixo: '',
    telefoneCelular: '',
  },
  configuracoesNotificacao: {},
  carregandoAplicacao: true,
};

export default (state = INITIAL_STATE, action) => {
  const { type, payload } = action;

  switch (type) {
    case USR_SET_PESSOA_LOGADA_SUCCESS:
      return { ...state, pessoaLogada: payload, carregandoAplicacao: false };
    case USR_SET_PESSOA_SUCCESS:
      return { ...state, dadosPessoa: payload };
    case USR_CONFIGURACAO_NOTIFICACAO_SUCESSO:
      return { ...state, configuracoesNotificacao: payload };
    default:
      return state;
  }
};
